import React from "react";
import OrderTable from "@commons/orders/Table";

const OrderList = ({ customerId }: { state: any; customerId: number }) => {
  return (
    <div style={{ padding: "20px 0" }}>
      <OrderTable
        type="All"
        initialFilters={
          {
            customerId: customerId,
          } as any
        }
      />
    </div>
  );
};

export default OrderList;
